<script setup lang="ts">
import { computed } from 'vue';
import { getCurrency, type TransactionTableRow } from '@peanuds/shared';
import {
  accountsEuroIcon as EuroIcon,
  accountsUsdIcon as UsdIcon,
  accountsGbrIcon as GbrIcon,
} from '@peanuds/ui';

const { row, showIcon = false } = defineProps<{
  row: { currency?: string };
  showIcon?: boolean;
}>();

const currencyIcon = computed(() => {
  if (!showIcon) return null;
  switch (row.currency) {
    case 'USD':
      return UsdIcon;
    case 'GBP':
      return GbrIcon;
    case 'EUR':
    default:
      return EuroIcon;
  }
});
</script>

<template>
  <span class="cell-currency">
    <template v-if="showIcon">
      <span class="cell-currency__icon-wrapper">
        <img v-if="currencyIcon" :src="currencyIcon" alt="" class="cell-currency__icon" />
      </span>
    </template>
    <template v-else>
      {{ getCurrency(row as TransactionTableRow) }}
    </template>
  </span>
</template>

<style scoped lang="scss">
.cell-currency {
  &__icon-wrapper {
    // Design: 30x30 rounded currency indicator; no token exists for 30px.
    width: f(30, 30);
    height: f(30, 30);
    border-radius: $radius-999;
    background: var(--p-surface-0);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__icon {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>
